import { CommonModule } from '@angular/common';

import { NgModule } from '@angular/core';

import { ActDocumentListComponent } from './act-document-list.component';
@NgModule({
  declarations: [ActDocumentListComponent],
  imports: [CommonModule],
  exports: [ActDocumentListComponent]
})
export class ActDocumentListModule {}
